import React, { FC, PropsWithChildren } from 'react';
import classNames from 'classnames';

import { Hint } from 'app/design-system/components/Popper';

import styles from '../../ScoreboardCells.module.scss';

type MatchScoreboardCellWrapperProps = PropsWithChildren<{
  content: string;
  className?: string;
  isDivWrapperTag?:boolean;
}>;

const ScoreboardCellWrapper: FC<MatchScoreboardCellWrapperProps> = ({
  content,
  className,
  isDivWrapperTag = false,
  children,
}) => {
  const wrapperClassNames = classNames(styles.scoreboardCellsWrapper, {
    [styles.noTitleContent]: !content.length,
  }, className);

  if (!content.length) {
    return (
      <>
        {isDivWrapperTag
          ? (
            <div className={wrapperClassNames}>{children}</div>
          ) : (
            <li className={wrapperClassNames}>{children}</li>
          )
        }
      </>
    );
  }

  return (
    <Hint content={content}
          childrenWrapperClassName={wrapperClassNames}
          childrenWrapperTag={isDivWrapperTag ? 'div' : 'li'}
          placement="top">
      {children}
    </Hint>
  );
};

export default ScoreboardCellWrapper;
